<i18n lang='yml' src='../i18n/SeriesForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          <span>
            {{type == 'new' ? $t('header') : $t('exam_series')}}
          </span>
        </h4>
      </div>
      <flash :message_type="message_type" :message_text="message_text"/>
      <Form class="content-block mt-4 p-4" ref="observer" v-slot="{ errors }" @submit="submitUserInput">
          <p v-if="type == 'edit'" class="border-bottom">
            <font-awesome-icon :icon="['fas', 'exclamation-circle']"/>
            <span>
              {{ $t('guiding_text') }}
            </span>
          </p>
          <fieldset class="form-group border-bottom">
            <div class="form-group row">
              <div class='col-12 col-md-6 col-lg-4 col-xl-3'>
                <Field
                  :name="$t('start_date')"
                  v-model='series.start_date'
                  :rules="type == 'edit' ? '' : `required|date_not_in_past:@${$t('start_time')}|date_not_after_end_date:@${$t('start_time')},@${$t('end_date')},@${$t('end_time')}`"
                  v-slot="{ errors, ariaMsg, field }">
                  <label :for="$t('start_date')">
                    {{$t('start_date')}}
                  </label>
                  <flat-pickr :config="dateConfig"  class="form-control"  input-class='form-control' :id="$t('start_date')"
                    name="start_date"
                    ref="start_date"
                    :disabled="type == 'edit'"
                    v-bind="field"
                    v-model='series.start_date'
                    :class="{'is-invalid': errors[0], 'disabled-flat-picker' : type == 'edit' }"
                    />
                  <div v-bind="ariaMsg" class="invalid-feedback" id="date" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span>{{ errors[0] }}</span>
                    </div>
                </Field>
              </div>

              <div class='col-12 col-md-6 col-lg-4 col-xl-3'>
                <Field
                  :name="$t('end_date')"
                  :rules="type == 'edit' ? '' : `required|date_not_in_past:@${$t('end_time')}`"
                  v-model='series.end_date'
                  v-slot="{ errors, ariaMsg, field }">
                  <label :for="$t('end_date')">
                    {{$t('end_date')}}
                  </label>
                  <flat-pickr :config="dateConfig"  class="form-control"  input-class='form-control' :id="$t('end_date')"
                    name="end_date"
                    ref="end_date"
                    v-bind="field"
                    v-model='series.end_date'
                    :disabled="type == 'edit'"
                    :class="{'is-invalid': errors[0], 'disabled-flat-picker' : type == 'edit' }"
                    ></flat-pickr>
                  <div v-bind="ariaMsg" class="invalid-feedback" id="end_date" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span>{{ errors[0] }}</span>
                    </div>
                </Field>
              </div>
            </div>
            <div class="form-group row">
              <div class='col-12 col-md-6 col-lg-4 col-xl-3'>
                <Field
                  :name="$t('start_time')"
                  v-model='series.start_time'
                  :rules="`required|time_not_in_past:${type == 'new' ? series.start_date : calculatedStartDate}`"
                  v-slot="{ errors, ariaMsg, field}">
                  <label :for="$t('start_time')">
                    {{$t('start_time')}}
                  </label>
                  <flat-pickr
                    :config="timeConfig"
                    class="form-control"
                    input-class='form-control'
                    ref="start_time"
                    v-model='series.start_time'
                    :id="$t('start_time')"
                    name="start_time"
                    v-bind="field"
                    :class="{'is-invalid': errors[0]}"
                    ></flat-pickr>
                  <div class="invalid-feedback" v-bind="ariaMsg" id="start_time" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span>{{ errors[0] }}</span>
                  </div>
                  <input type="hidden" :value="`${series.start_time} ${timezone}`">
                </Field>
              </div>
              <div class='col-12 col-md-6 col-lg-4 col-xl-3'>
                 <Field
                  :name="$t('end_time')"
                  v-model='series.end_time'
                  :rules="`required|not_before_start_time:@${$t('start_time')}|time_not_in_past:${type == 'new' ? series.start_date : calculatedStartDate}`"
                  v-slot="{ errors, ariaMsg, field }">
                  <label :for="$t('end_time')">
                    {{$t('end_time')}}
                  </label>
                  <flat-pickr
                    :config="timeConfig"
                    class="form-control"
                    input-class='form-control'
                    v-model='series.end_time'
                    ref="end_time"
                    :id="$t('end_time')"
                    name="end_time"
                    v-bind="field"
                    :class="{'is-invalid': errors[0]}"
                    ></flat-pickr>
                  <div class="invalid-feedback" v-bind="ariaMsg" id="end_time" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span>{{ errors[0] }}</span>
                  </div>
                  <input type="hidden" :value="`${series.end_time} ${timezone}`">
                </Field>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-12">
                <label :for="$t('frequency')"> {{$t('frequency')}} </label>
                 <span class="red">*</span>
                <div class="checkbox"  >
                  <div class="d-md-flex" :class="{'is-invalid': errors[$t('frequency')]}">
                    <div class="checkbox mr-3" v-for="(day, index) in days" :key="day.id">
                      <label>
                        <Field
                          :id="day.id"
                          :disabled="type == 'edit'"
                          class="weekdays"
                          v-model="daysSelected"
                          rules="required"
                          :name="$t('frequency')"
                          :value="index"
                          type="checkbox"
                        />
                        {{day.text}}
                      </label>

                    </div>
                  </div>
                  <div class="invalid-feedback" v-bind="ariaMsg"
                    v-if="errors[$t('frequency')]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span >  {{ errors[$t('frequency')] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6 col-lg-3">
                <Field
                  :name="$t('number_of_seats')"
                  vid="number_of_seats"
                  :rules="privateRoomEnabled ? 'required|numeric' : 'required|numeric|greater_than_zero'"
                  v-model="series.number_of_seats"
                  v-slot="{ errors, ariaMsg, ariaInput, field }">
                  <label :for="$t('number_of_seats')">
                    {{$t('number_of_seats')}}<span class="red">*</span>
                  </label>
                  <input
                    :id="$t('number_of_seats')"
                    name="number_of_seats"
                    type="number"
                    class="form-control"
                    maxlength="4"
                    v-bind="field"
                    :class="{'is-invalid': errors[0]}"
                     >
                  <div class="invalid-feedback" v-bind="ariaMsg"
                  id="number_of_seats" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                    <span>{{ errors[0] }}</span>
                    </div>
                </Field>
              </div>
            </div>

            <div class="form-group">
                <label>{{$t('local_only')}}</label>
                <span class="red">*</span>
                <div class="col-sm-6">
                  <div class="form-check form-check-inline">
                    <label :for="`${$t('local_only')}_true`" class="form-check-label" >
                      <input type="radio" :id="`${$t('local_only')}_true`"
                      :aria-checked="`${$t('local_only')}_true`" :value="true" v-model="series.local_only" >
                      {{$t('yes_val')}}
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <label class="form-check-label" :for="`${$t('local_only')}_false`" >
                      <input type="radio" :id="`${$t('local_only')}_false`"
                      :aria-checked="`${$t('local_only')}_false`" :value="false" v-model="series.local_only" >
                      {{$t('no_val')}}
                    </label>
                  </div>
                </div>
            </div>

            <div class="form-group">
              <label>{{$t('allow_online_booking')}}</label>
              <span class="red">*</span>
              <div class="col-sm-6">
                <div class="form-check form-check-inline">
                  <label :for="`${$t('allow_online_booking')}_true`" class="form-check-label" >
                    <input type="radio" :id="`${$t('allow_online_booking')}_true`"  :aria-checked="`${$t('allow_online_booking')}_true`"
                    :value="true" v-model="series.allow_online_booking" >
                    {{$t('yes_val')}}
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <label :for="`${$t('allow_online_booking')}_false`" class="form-check-label">
                    <input type="radio" :id="`${$t('allow_online_booking')}_false`" :aria-checked="`${$t('allow_online_booking')}_false`"
                     :value="false" v-model="series.allow_online_booking" >
                    {{$t('no_val')}}
                  </label>
                </div>
              </div>
            </div>


            <div class="form-group">
                <label :for="$t('exam_booth_available')">
                  {{$t('exam_booth_available')}}
                </label>
                <span class="red">*</span>
                <div class="col-sm-6" :id="$t('exam_booth_available')">
                  <div class="form-check form-check-inline" :class="{'is-invalid': errors[0]}">
                    <label class="form-check-label">
                      <input
                        type="radio"
                        v-model="series.exam_booth_available"
                        :id="`${$t('exam_booth_available')}_true`"
                        :name="`${$t('exam_booth_available')}_true`"
                        :aria-checked="`${$t('exam_booth_available')}_true`"
                        :value="true"
                        @click="setBoothCapacity(2)"
                         >
                      {{$t('yes_val')}}
                    </label>

                  </div>
                  <div class="form-check form-check-inline" :class="{'is-invalid': errors[0]}">
                    <label class="form-check-label">
                      <input
                        type="radio"
                        :id="`${$t('exam_booth_available')}_false`"
                        :name="`${$t('exam_booth_available')}_false`"
                        :aria-checked="`${$t('exam_booth_available')}_false`"
                        :value="false"
                        @click="setBoothCapacity()"
                        v-model="series.exam_booth_available" >
                      {{$t('no_val')}}</label>
                  </div>
                </div>
            </div>
            <div class="form-group row">
              <div class="col-12 col-md-6 col-lg-3">
                <Field
                  :name="$t('booth_capacity')"
                  vid="booth_capacity"
                  :rules="privateRoomEnabled ? 'required|numeric|greater_than_zero' : ''"
                  v-model="series.booth_capacity"
                  v-slot="{ errors, ariaMsg, ariaInput, field }">
                  <label :for="$t('booth_capacity')">
                    {{$t('booth_capacity')}}
                  </label>
                  <span class="red">*</span>
                  <input
                    :id="$t('booth_capacity')"
                    name="booth_capacity"
                    class="form-control"
                    v-bind="field"
                    type="number"
                    maxlength="4"
                    :class="{'is-invalid': errors[0]}"
                    :disabled="!privateRoomEnabled">
                  <!-- <div class="invalid-feedback" v-bind="ariaMsg"
                    id="booth_capacity" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                  </div> -->

                  <div class="invalid-feedback" v-bind="ariaMsg" v-if="errors[0]">
                    <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      {{ errors[0] }}
                  </div>
                </Field>
              </div>
            </div>

            <div class="form-group">
              <label>{{$t('extra_time_available')}}</label>
              <span class="red">*</span>
              <div class="col-sm-6">
                <div class="form-check form-check-inline">
                  <label class="form-check-label" >
                    <input type="radio" :id="`${$t('extra_time_available')}_true`"
                    :aria-checked="`${$t('extra_time_available')}_true`" :value="true" v-model="series.extra_time_available" >
                    {{$t('yes_val')}}
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <label class="form-check-label">
                    <input type="radio" :id="`${$t('extra_time_available')}_false`"
                    :aria-checked="`${$t('extra_time_available')}_false`" :value="false" v-model="series.extra_time_available" >
                    {{$t('no_val')}}
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12 col-md-6 col-lg-4">
                <label> {{$t('status')}} </label>
                <span class="red">*</span>
                <select v-model="series.status" id="status" class="form-control">
                  <option v-for="status in sittingStatuses" :key="status.label" :value="status.label">
                    {{$t(status.label)}}
                  </option>
                </select>
              </div>
            </div>

          </fieldset>
          <div class="btn-row d-flex">
            <button v-if="type == 'new'" type="submit" class="btn btn-primary btn-success no-shadow" :disabled="loading">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{$t('submit')}}
            </button>
            <a v-else class="btn btn-primary btn-success no-shadow" :class="`${bulkUpdateSittings.length == 0 ? 'disabled' : ''}`" @click="submitBulkSittingChange">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{$t('update')}}
            </a>
            <a class="btn btn-light ml-auto" :href="redirect_to_sittings">
              <font-awesome-icon :icon="['fa', 'times']" />
              {{ $t('cancel') }}
            </a>
          </div>
      </Form>
    </div>
    <div v-if="type == 'edit'">
      <div class="layout-tile">

        <div class="d-flex my-4">
          <div v-if="bulkUpdateSittings.length > 0">
            <span class="book_count">{{bulkUpdateSittings.length}}</span>
            {{bulkUpdateSittings.length >= 2 ? $t('sessions') : $t('session')}} {{$t('selected')}}
          </div>
          <div class="ml-auto">
            <button class="btn btn-primary mr-4" href="#" @click="selectAll">
              {{ $t('select_all') }}
            </button>
            <button class="btn btn-secondary" href="#" @click="deselectAll">
              {{ $t('deselect_all') }}
            </button>
            </div>
          </div>
        </div>

        <div class="media-list">
        <div class="content-block" :class="`${!item['in_future?'] ? 'in-past' : ''}`" v-for="item in sittings" :key="item.id">
          <div class="post-meta">
            <ul class="list-inline list-annotation">
              <li>
                <h5 class="container-item-name">
                  {{`${$t('sitting')} ${parseInputDate(item.date, defaultDate)}`}}
                </h5>
              </li>
              <li v-if="item['in_future?']" class="list-inline-item ml-auto" >
                <label class="check-select">
                  <input :id="`item-${item.id}`" v-model="bulkUpdateSittings" type="checkbox" :value="item" />
                  <span>{{ $t('select') }}</span>
                </label>
              </li>
            </ul>
          </div>
          <div class="post-meta">
            <ul class="list-unstyled list-inline list-annotation">
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('status_metadata')}}
                </span>
                {{ $t(item.status) }}

              </li>
            </ul>
            <ul class="list-unstyled list-inline list-annotation">
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('start_time_metadata')}}
                </span>
                {{ formatTime(item.start_time) }}
              </li>
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('end_time_metadata')}}
                </span>
                {{ formatTime(item.end_time) }}
              </li>
            </ul>
            <ul class="list-unstyled list-inline list-annotation">
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('type_of_exam')}}
                </span>
                {{'All Exams'}}

              </li>
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('seat_metadata')}}
                </span>
                {{ item.number_of_seats}}

              </li>
              <li class="list-inline-item">
                <span class="status-bold">
                  {{$t('booth_metadata')}}
                </span>
                {{item.exam_booth_available ? $t('yes_val') : $t('no_val')}}

              </li>
            </ul>
          </div>
        </div>
        <pagination @items_changed="setItems" :items="sittingData" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
      </div>
    </div>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue'
  import {French} from 'flatpickr/dist/l10n/fr.js';
  import Pagination from '../../shared/pagination/Pagination.vue';
  import '../../../javascripts/application/vee-validate-rules'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../shared/typescripts/ajax.ts'
  import { Form, Field } from 'vee-validate'
  // import { useForm, useFieldArray } from 'vee-validate';
  // const { remove, push, fields } = useFieldArray('links');
  import {formatTime, commonizeTimeFormat} from '../../shared/typescripts/dates.ts'

  export default {
    props: ['locale', 'base_path', 'type', 'series_obj', 'sub_location_name', 'redirect_to_sittings', 'sitting_statuses', 'sitting_data', "pagination_limit", 'expansion_threshold', 'time_format_en', 'time_format_fr'],

    components: {
      'pagination': Pagination,
      flash,
      Form,
      Field
    },

    data() {
      const defaultDate = new Date();
      defaultDate.setHours(0, 0, 0, 0);
      const defaultStartTime = new Date();
      defaultStartTime.setMinutes(0, 0, 0);
      const defaultEndTime = new Date();
      defaultEndTime.setHours(defaultStartTime.getHours() + 1, 0, 0, 0);
      return {
        series: {
          start_date: null,
          end_date: null,
          exam_booth_available: false,
          extra_time_available: false,
          allow_online_booking: false,
          number_of_seats: 1,
          local_only: false,
          start_time: this.parseInputTime(defaultStartTime),
          end_time: this.parseInputTime(defaultEndTime),
          frequency: [],
          booth_capacity: 0,
          status: 'pending'
        },

        days: [
          {id: 1, day: 'mondays', selected: false, text: this.$i18n.t('mondays')},
          {id: 2, day: 'tuesdays', selected: false, text: this.$i18n.t('tuesdays')},
          {id: 3, day: 'wednesdays', selected: false, text:this.$i18n.t('wednesdays')},
          {id: 4, day: 'thursdays', selected: false, text: this.$i18n.t('thursdays')},
          {id: 5, day: 'fridays', selected: false, text: this.$i18n.t('fridays')}
        ],
        daysSelected: [],
        bulkUpdateSittings: [],
        calculatedStartDate: defaultDate,
        defaultDate: defaultDate,
        defaultStartTime: new Date(defaultStartTime).toLocaleTimeString(),
        defaultEndTime: new Date(defaultEndTime).toLocaleTimeString(),
        timezone: new Date().getTimezoneOffset() / 60,
        sittings: [],
        loading: false,
        error: false,
        message_type: "",
        message_text: [],
        sittingStatuses: [],
        showErrorBanner: false,
        ariaInput: "",
        ariaMsg: "",
        dateConfig: {
          enableTime: false,
          locale: (this.locale=='fr') ? French : 'en',
          disable: [
            function(date) {
                return (date.getDay() === 0 || date.getDay() === 6);
            },
          ]
        },
        timeConfig: {
          enableTime: true,
          dateFormat: this.locale == 'en' ? "h:iK" : "H\\hi",
          minuteIncrement: 30,
          noCalendar: true,
          time_24hr: this.locale != 'en'
        }


      }
    },

    watch: {
    bulkUpdateSittings(newVal) {
      if(newVal && newVal.length == 1) {
        this.calculatedStartDate = newVal[0].date
      }
      else if (newVal.length > 1) {
        let tempDate = null
        newVal.map((sitting) => {
          if (tempDate == null) {
            tempDate = sitting.date
          } else if (sitting.date < tempDate) {
            tempDate = sitting.date
          }
        })
        this.calculatedStartDate = tempDate
      }
      else {
        this.calculatedStartDate = this.firstAvailableDate
      }
      let timeValues = this.getStartTimeValues()
      this.calculatedStartDate = new Date(this.calculatedStartDate)
      this.calculatedStartDate.setHours(timeValues.hours, timeValues.minutes, 0, 0);
    },
  },

    created() {
      this.$i18n.locale = this.locale;
      this.days.forEach(day => { day.text = this.$i18n.t(day.day) });

      try{
        if(this.series_obj){
          this.series = JSON.parse(this.series_obj)
          this.days = JSON.parse(this.series.frequency)
          this.days.map((day, index) => {
            if (day.selected == true) {
              this.daysSelected.push(index)
            }
            day.text = this.$i18n.t(`${day.day}`)
          })

          this.series.start_date = this.parseInputDate(this.series.start_date, this.defaultDate)
          this.series.end_date = this.parseInputDate(this.series.end_date, this.defaultDate)
          this.series.start_time = this.parseInputTime(this.series.start_time, this.defaultStartTime)
          this.series.end_time = this.parseInputTime(this.series.end_time, this.defaultEndTime)

          this.sittingData = JSON.parse(this.sitting_data)

          if (this.sittingData.length > 0) {
            this.calculatedStartDate = this.sittingData.find(sitting => {
              let d =  new Date(sitting.date)
              let hours = new Date(sitting.start_time).getHours();
              let minutes =  new Date(sitting.start_time).getMinutes();
              const a = d.setHours(hours, minutes, 0, 0);
              return a >= new Date();
          }).date
          this.firstAvailableDate = this.calculatedStartDate
          }
        }

        else  {
          this.series.start_date = this.parseInputDate(this.defaultDate)
          this.series.end_date = this.parseInputDate(this.defaultDate)
        }
        this.sittingStatuses = JSON.parse(this.sitting_statuses)
        this.series.status = 'pending';

      }
      catch(err) {
        this.error = true;
      }


    },

    computed: {
      privateRoomEnabled() {
        return this.series.exam_booth_available === true;
      }
    },

    methods: {
      getHoursAndMinutes(time) {
        time = commonizeTimeFormat(time)
        return time
      },
      setBoothCapacity(value=0) {
        this.series.booth_capacity = value
      },
      getStartTimeValues() {
        return commonizeTimeFormat(this.series.start_time)
      },
      getDate() {
        if (this.type && this.type === 'new') {

          return this.series.start_date
        } else {
          if (this.sittings.length > 0) {
            return this.getDateNotInPast(this.sittings) || this.defaultDate()
          }
        }


      },
      parseInputDate: function (date, fallback = null) {
          if (date === null) {
              if (fallback === null) {
                  return fallback;
              }

              const year = fallback.getFullYear();
              const month = ('0' + (fallback.getMonth() + 1)).slice(-2);
              const day = ('0' + fallback.getDate()).slice(-2);
              return `${year}-${month}-${day}`;
          }

          const dateObj = new Date(date);
          const parsedDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
          const year = parsedDate.getFullYear();
          const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
          const day = ('0' + parsedDate.getDate()).slice(-2);
          return `${year}-${month}-${day}`;
      },
      parseInputTime: function (date, fallback = null) {
          if (date === null) {
              if (fallback === null) {
                  return fallback;
              }
              return `${fallback.getHours()}:${fallback.getMinutes() == 0 ? '00' : fallback.getMinutes()}`;
          }

          const dateObj = new Date(new Date(date).toLocaleString('en-US', { timeZone: 'America/Toronto' }));
          return `${dateObj.getHours()}:${dateObj.getMinutes() == 0 ? '00' : dateObj.getUTCMinutes()}`;
      },
      datePickerConfig: function () {
        return {
          enableTime: false,
          locale: (this.locale=='fr') ? French : 'en',
        };
      },
      setItems(items) {
        this.sittings = items
      },
      timePickerConfig: function () {
          return {
              enableTime: true,
              minuteIncrement: 30,
              noCalendar: true,
              time_24hr: this.locale != 'en'
          };
      },
      async handleConfirmations() {
        this.series.frequency = JSON.stringify(this.days);
        if(this.bulkUpdateSittings.length > 0)
        {
          this.series.sittings_to_update = this.bulkUpdateSittings.map((item) => {return item.id})
        }
        let warningsData = await sendAjaxRequest('POST', `${this.base_path}/series_warnings`, 'json', { series: this.series }, this.successReturn, this.throwError)

        let confirmAll = true
        Object.keys(warningsData.warnings).forEach((warning) => {
          if(!confirmAll) {
            return
          }
          else if(warningsData.warnings[warning].result) {
            if(!confirm(this.$i18n.t(warning, warningsData.warnings[warning].opts))) {
              confirmAll = false
            }
          }
        })
        return confirmAll && this.cancellationConfirmation()
      },
      cancellationConfirmation() {
        if(this.series.status == "cancelled" && !confirm(this.$i18n.t('cancel_confirmation'))) {
          return confirm(this.$i18n.t('cancel_confirmation'))
        }
        return true
      },

      successRedirect(response) {
        if(response.error){
          this.message_type = "error";
          this.message_text.push(response.error)
        }
        else {
          window.location.replace(response.path);
        }
      },
      successReturn(response) {
        if(response.error){
          this.message_type = "error";
          this.message_text.push(response.error)
        }
        return response
      },

      async submitUserInput(event){
        if(this.loading) return;
        this.loading = true;
        // Make sure days are selected properly
        this.daysSelected.map((day) => {
          this.days[day].selected = true
        })
        this.message_text = [];
        let send_type = 'POST'
        let path = this.base_path
        let userConfirm = await this.handleConfirmations();
        if(!userConfirm) {
          this.loading = false;
          return;
        }

        this.series.frequency = JSON.stringify(this.days);
        sendAjaxRequest(send_type, path, 'json', { series: this.series }, ajaxResponseMessage, this.throwError)
      },

      throwError() {
        this.loading = false;
        console.log("ERROR")
      },

      selectAll(e) {
        e.preventDefault();
        this.sittingData.forEach((item) => {
          if(this.bulkUpdateSittings.indexOf(item) == -1 && item['in_future?']) {
            this.bulkUpdateSittings.push(item);
          }
        })
      },
      deselectAll(e) {
        e.preventDefault();
        this.bulkUpdateSittings= [];
      },

      async submitBulkSittingChange(event){
        let userConfirm = await this.handleConfirmations();

        if(!userConfirm || !this.bulkUpdateSittings || this.bulkUpdateSittings.length == 0) {
          return
        }

        this.loading = true
        var send_type= 'POST'
        var path= `${this.base_path}/bulk_sittings_update`
        var data= {
          series: this.series,
          sittings_id_array: this.bulkUpdateSittings.map((item) => {return item.id})
        }

        this.series.frequency = JSON.stringify(this.days);
        sendAjaxRequest(send_type, path, 'json', { series: data }, ajaxResponseMessage, this.throwError)
      },
      formatTime: function (date) {
        let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
        return formatTime(date, format)
      },
    }
 }
</script>
